import clock from '../../assets/aboutuspage/icons/clock.png'
import safety from '../../assets/aboutuspage/icons/safety.png'
import innovation from '../../assets/aboutuspage/icons/innovation.png'
import ownership from '../../assets/aboutuspage/icons/ownership.png'

const data = [
    {
        id: 1,
        img: clock,
        title: 'Fast results',
        para: 'We shorten the time from the moment a client approaches us to the moment they experience our solutions’ benefits.'
    },
    {
        id: 1,
        img: safety,
        title: 'Safety & Reliability',
        para: 'We shorten the time from the moment a client approaches us to the moment they experience our solutions’ benefits.'
    },
    {
        id: 3,
        img: innovation,
        title: 'Innovation',
        para: 'Our solutions are safe out-of-the-box and don’t require additional security measures. Once implemented, they work forever.'
    },
    {
        id: 4,
        img: ownership,
        title: 'Ownership',
        para: 'We’re a team of passionate, dedicated experts, and we care about our clients’ business as if it were our own.'
    },
]

export default data;